import Helpers from "./helpers";

export default class ProductVariantsGallery {

	private activeClass = 'c-product__variants__link--active';
	private doneClass = 'js-product-variant-done';

	constructor(elements: HTMLElement[]) {

		if (!elements.length) return;

		this.attachEvents(elements);

	}

	private attachEvents(elements: HTMLElement[]) {

		for (let i = 0; i < elements.length; i++) {

			let element = elements[i] as HTMLElement;

			element.addEventListener('mouseenter', (e) => {

				if (!Helpers.hasUserTouched()) {

					this.handleVariantInteraction(e, false);

				}

			});

			element.addEventListener('focus', (e) => {

				this.handleVariantInteraction(e, false);


			});

			element.addEventListener('click', (e) => {

				this.handleVariantInteraction(e, true);
				return false;

			});

			element.classList.add(this.doneClass);

		}

	}

	private handleVariantInteraction(e: Event, checkAndRedirect: Boolean) {

		e.preventDefault();
		e.stopPropagation();

		const target = (e.currentTarget as HTMLElement).closest('a.js-product-variant') as HTMLElement || e.currentTarget as HTMLElement;

		if (checkAndRedirect && target.classList.contains(this.activeClass)) {
			const href = target.getAttribute('href');
			if (href) {
				window.location.href = href;
			}
			return;
		}

		const productGuid = target.getAttribute('data-product-guid');
		const product = target.closest('.js-product') as HTMLElement;
		const variants = product.querySelectorAll('.js-product-variant');

		this.updateVariants(variants);

		target.classList.add(this.activeClass);

		this.navigateCarousel(productGuid, product);

	}

	private updateVariants(variants: NodeList) {

		for (let i = 0; i < variants.length; i++) {

			let variant = variants[i] as HTMLElement;
			variant.classList.remove(this.activeClass);

		}

	}

	private navigateCarousel(productGuid: string, product: HTMLElement) {
		if (!productGuid) {
			return;
		}

		const productCard = product.closest('product-card') as any;
		
		if (!productCard) {
			return;
		}

		if (typeof productCard.navigateCarouselToVariant === 'function') {
			productCard.navigateCarouselToVariant(productGuid);
		}
	}

}

